import { useSyncExternalStore } from "react";

// Whether the company has more than one branch. Set by the Branch box in the top bar; lists only show a
// record's branch when there is more than one to tell apart.
let multi = false;
const listeners = new Set();

export function setMultiBranch(value) {
  if (value === multi) return;
  multi = value;
  listeners.forEach((fn) => fn());
}

export function useMultiBranch() {
  return useSyncExternalStore(
    (fn) => { listeners.add(fn); return () => listeners.delete(fn); },
    () => multi,
  );
}

// For list cards that take a "meta" array: the branch name when it's worth showing, otherwise nothing.
export const branchMeta = (row, multi) => (multi && row?.branch_name ? [row.branch_name] : []);

// For list cards: which company and who raised the document. The company is named only when the organisation has more than one.
export const raisedMeta = (row, singleCompany) => [
  ...(!singleCompany && row?.company_name ? [row.company_name] : []),
  ...(row?.requested_by_name ? [`Raised by ${row.requested_by_name}`] : []),
];
